import { Download } from "lucide-react";
import { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import { usePdfExport } from "../../pdf/PdfExportContext";
import ClubReportPdf from "./ClubReportPdf";

function normalizeLogoSync(raw) {
  if (!raw) return null;
  const s = String(raw);
  if (s.startsWith("data:")) return s;
  if (/^https?:\/\//i.test(s)) return s; // on laissera la version async gérer le fetch si besoin
  return `data:image/png;base64,${s}`;
}

async function toDataUrlIfHttp(url) {
  if (!/^https?:\/\//i.test(String(url))) return url;
  try {
    const res = await fetch(url, { mode: "cors" });
    const blob = await res.blob();
    const reader = new FileReader();
    return await new Promise((resolve) => {
      reader.onload = () => resolve(reader.result); // -> data:image/...;base64
      reader.readAsDataURL(blob);
    });
  } catch {
    return url; // on tente tel quel si CORS bloqué (mais peut échouer)
  }
}

export default function DownloadClubPdfButton({ club, season, teamStats, byPosition, logoDataUrl }) {
  const [loading, setLoading] = useState(false);
  const exporter = usePdfExport();

  const handleDownload = async () => {
    setLoading(true);
    try {
      const images = exporter.getAllImages();
      const data   = exporter.getAllData();
      let logoSrc = normalizeLogoSync(logoDataUrl);
      logoSrc = await toDataUrlIfHttp(logoSrc);

      const blob = await pdf(
        <ClubReportPdf
          club={club}
          season={season}
          teamStats={teamStats}
          byPosition={byPosition}
          images={images}
          data={data}
          logoDataUrl={logoSrc}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `rapport_club_${season}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="flex items-center gap-1 px-3 py-2 text-sm font-medium rounded-lg bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-40"
      disabled={loading}
      title="Exporter le rapport club en PDF"
    >
      {loading ? (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="3" fill="none" />
        </svg>
      ) : <Download size={16} />}
      <span className="hidden md:inline">Exporter</span>
    </button>
  );
}
